import React, { useEffect, useState } from 'react';
import { InputDialog, Text, Spinner, Button } from 'wix-ui-tpa/cssVars';
import { classes, st } from './PolicyModal.st.css';
import { BookingPolicyModalDataHooks } from './datahooks';
import { groupBy } from 'lodash';
const policyMapper = policies => {
  const organizedPolicies = Object.values(groupBy(policies, policy => policy.policyId));
  return organizedPolicies
  // eslint-disable-next-line @typescript-eslint/no-shadow
  .map(policies => ({
    serviceNames: Object.values(groupBy(policies, policy => policy.serviceId)).map(grouppedPolicies => grouppedPolicies[0].serviceName).join(', '),
    policyDescription: policies[0].policyDescription,
    policyId: policies[0].policyId
  })).filter(policy => policy.policyDescription);
};
const renderSpinner = () => /*#__PURE__*/React.createElement("div", {
  className: classes.spinnerWrapper
}, /*#__PURE__*/React.createElement(Spinner, {
  "data-hook": BookingPolicyModalDataHooks.Spinner,
  isCentered: true
}));
const Footer = _ref => {
  let {
    primaryButtonText,
    onClick,
    isMobile
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.footer,
    "data-hook": BookingPolicyModalDataHooks.Footer
  }, /*#__PURE__*/React.createElement(Button, {
    fullWidth: isMobile,
    className: classes.primaryButton,
    "data-hook": BookingPolicyModalDataHooks.PrimaryButton,
    onClick: onClick,
    upgrade: true
  }, primaryButtonText));
};
const renderPolicies = policies => /*#__PURE__*/React.createElement("div", {
  className: classes.contentWrapper
}, policies.map(policy => /*#__PURE__*/React.createElement("div", {
  className: classes.policyCard,
  "data-hook": `${BookingPolicyModalDataHooks.PolicyDescriptionCard}-${policy.policyId}`,
  key: policy.policyId
}, policies.length > 1 && /*#__PURE__*/React.createElement(Text, {
  className: classes.serviceNames,
  tagName: "p",
  "data-hook": `${BookingPolicyModalDataHooks.PolicyDescriptionTitle}-${policy.policyId}`
}, policy.serviceNames), /*#__PURE__*/React.createElement(Text, {
  className: classes.policyDescription,
  tagName: "p",
  "data-hook": `${BookingPolicyModalDataHooks.PolicyDescriptionContent}-${policy.policyId}`
}, policy.policyDescription))));
export const BookingPolicyModal = _ref2 => {
  let {
    className,
    modalTitle,
    policies,
    primaryButtonText,
    isOpen,
    isLoading,
    onPrimaryButtonClick,
    onClose,
    dataHook,
    isMobile
  } = _ref2;
  const [mappedPolicies, setMappedPolicies] = useState([]);
  useEffect(() => {
    setMappedPolicies(policyMapper(policies));
  }, [policies]);
  return /*#__PURE__*/React.createElement(InputDialog, {
    "data-hook": dataHook,
    className: st(classes.root, {
      mobile: isMobile
    }, className),
    isOpen: isOpen,
    title: modalTitle,
    onClose: onClose,
    customFooter: /*#__PURE__*/React.createElement(Footer, {
      primaryButtonText: primaryButtonText,
      onClick: onPrimaryButtonClick,
      isMobile: isMobile
    })
  }, isLoading ? renderSpinner() : renderPolicies(mappedPolicies));
};
//# sourceMappingURL=index.js.map